"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.env = void 0;
var dev = {
  API_ENDPOINT_URL: 'https://jsonplaceholder.typicode.com'
};
var prod = {
  API_ENDPOINT_URL: 'https://api.prod.com'
};
var test = {
  API_ENDPOINT_URL: 'https://api.test.com'
};

var getEnv = function getEnv() {
  switch (process.env.NODE_ENV) {
    case 'development':
      return dev;

    case 'production':
      return prod;

    case 'test':
      return test;

    default:
      break;
  }
};

var env = getEnv();
exports.env = env;